import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import * as jsondiffpatch from "jsondiffpatch";
import 'app/styles/vendor/jsondiffpatch.css';
// @ts-ignore
import * as htmlFormatter from "jsondiffpatch/formatters/html";

@AsStimulusController('crm-person-detail-bank-id-verifications')
export default class extends Typed(
    Controller<HTMLElement>, {
        values: {
            firstItem: Object,
            secondItem: Object,
        },
        targets: {
            diffResult: HTMLElement,
            diffResultContainer: HTMLElement,
        }
    }
)
{
    public firstItemValueChanged(): void {
        this.renderDiff();
    }

    public secondItemValueChanged(): void {
        this.renderDiff();
    }

    private renderDiff(): void {
        if (!this.hasDiffResultTarget) {
            return;
        }
        if (!this.hasFirstItemValue || !this.hasSecondItemValue) {
            this.diffResultTarget.innerHTML = '';
            this.diffResultContainerTarget.style.display = 'none';
            return;
        }
        const delta = jsondiffpatch.diff(this.firstItemValue, this.secondItemValue);
        if (delta === undefined) {
            this.diffResultTarget.innerHTML = '';
            this.diffResultContainerTarget.style.display = 'none';
            return;
        }
        this.diffResultContainerTarget.style.display = '';
        this.diffResultTarget.innerHTML = htmlFormatter.format(delta, this.firstItemValue);
    }
}
